<div class="panel-body " *ngIf="dispositionResult===undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
        <div class="panel-title">
          Disposition Result
        </div>
        <div class="panel-body ">
            No Disposition Result information available for this allegation.
        </div>
    </div>
  </div>
<!-- <div class="panel-body " *ngIf="dispositionResult===undefined">
        No Disposition Result information available for this allegation.
      </div> -->
<div class="panel-body " *ngIf="dispositionResult!==undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Disposition Result
      </div>
     <div class="panel-body ">
        <div class="col-md-6 panel panel-default">
            <div class="panel panel-default " *ngIf="dispositionResult.getDispositionDate() !== ''">
            <div class="panel-title">
                Disposition Date
            </div>
            <div class="panel-body"></div>
               {{dispositionResult.getDispositionDate() | date:'MM/dd/yyyy'}}
            </div>
            <div class="panel panel-default " *ngIf="dispositionResult.getParents().length !==0">
            <div class="panel-title">
                Parent/Guardian/Custodian Assigned
            </div>
            <div class="panel-body" *ngFor="let parent of dispositionResult.getParents(); let al = index">
                {{parent.getPartyName() + ' (' + parent.getRelationship() + ')'}}
            </div>
            </div>
        </div>
        <div class="col-sm-6 panel panel-default ">
          <div class="panel panel-default " *ngIf="dispositionResult.getDispositionEoDate() !== ''">
          <div class="panel-title">
            Disposition EO Date
          </div>
          <div class="panel-body">
              {{dispositionResult.getDispositionEoDate() | date:'MM/dd/yyyy'}}
          </div>
          </div>
        </div>
        </div>
        <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
                <div class="panel panel-default" *ngIf="dispositionResult.getOtherAllegations().length !=0">
                        <div class="panel-title">
                          Other Allegations Included On Order
                        </div>
                        <div class="panel-body" >
                            <div class="row table-responsive">
                                <table id="allegations-table" class="table table-condensed table-striped">
                                    <thead>
                                        <tr>
                                            <th id="V122c">
                                              <span class="field-code ">V122c json='allegations.pleadingType'</span>
                                              Pleading Type <br> 
                                              <span class="field-code ">V122c json='allegations.clockDate'</span>
                                              And Clock Date
                                            </th>
                                            <th id="V121c">
                                              <span class="field-code ">V121c json='allegations.allegation'</span>
                                                Allegation <br>
                                                <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                                Offense Date
                                              </th>
                                             </tr>
                                    </thead>
                                    <tbody  *ngFor="let otherAllegation of dispositionResult.getOtherAllegations()let i = index;">                            
                                         <tr >
                                          <td id="{{'juvenile-caseDetails-dispositionResult-' + i + '-pleadingType'}}">
                                            {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                                            {{otherAllegation.getOtherPleadingDate()}} {{otherAllegation.getOtherPleadingTime()}}</td>
                                          <td id="{{'juvenile-caseDetails-dispositionResult-' + i + '-allegationDescription'}}">
                                            {{otherAllegation.getOtherAllegationDescription()}} <br>        
                                            {{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
                                        </tr>    
                                       </tbody>
                                </table>
                            </div>
                        </div>
                        </div>
          <div class="panel panel-default">
            <div class="panel-title">
              Findings
            </div>
           <div class="panel-body">
              <B>Based on the evidence presented, the Court makes the following Findings of Fact:</B>
              <ul style="list-style-type:disc">
                <span *ngIf="dispositionResult.getDispositionDelinquentHistoryLevel()!==''">
                <li>The juvenile's delinquency history level is&nbsp;{{dispositionResult.getDispositionDelinquentHistoryLevel()}}</li></span>
                <span *ngIf="dispositionResult.getDispositionDelinquentCourtConsidered()!=='' || dispositionResult.getDispositionDelinquentIncorporateContent()!==''">
                <li>The Court received and considered&nbsp;{{dispositionResult.getDispositionDelinquentCourtConsidered()}}&nbsp;
                    and incorporates the contents of the &nbsp; {{dispositionResult.getDispositionDelinquentIncorporateContent()}}
                </li></span>
                <span *ngIf="dispositionResult.getOtherFindings()!==''">
                <li>Other Findings:</li>
                <ul style="list-style-type:disc">
                 <li>{{dispositionResult.getOtherFindings()}} </li>
                </ul></span>
              </ul>
           </div>
          </div>
        <div class="panel panel-default" *ngIf="dispositionResult.getConclusionsOfLawFlag() !== ''">
            <div class="panel-title">
              Conclusions of Law
            </div>
            <div class="panel-body">
              <B>Based on the foregoing findings of fact, the Court concludes as a matter of law that:</B>
              <ul style="list-style-type:disc">
                <li>{{dispositionResult.getConclusionsOfLawFlag()}}</li>
              </ul>
            </div>
        </div>
        <div class="panel panel-default" *ngIf="dispositionResult.isOrderDetailsPresent() === true">
            <div class="panel-title">
              Order
            </div>
            <div class="panel-body">
               <div *ngIf="dispositionResult.isOrderLevel1DetailsPresent() === true"> 
              <B>Level 1:</B>
              <ul style="list-style-type:disc">
                <div *ngIf="dispositionResult.getProbationIndicator() === 'Y'" >    
                <li>Probation [G.S 7B-2506(8)]:</li>
                <span *ngIf="dispositionResult.getProbationDuration() !== ''">
                <ul style="list-style-type:disc">
                  <li> Probation Duration:{{dispositionResult.getProbationDuration()}}. </li>
                </ul></span>
                </div>
                <div *ngIf="dispositionResult.getHomeSupervisionIndicator() === 'Y'" >
                    <li>In-Home Supervision with conditions [G.S 7B-2506(1)a.]:</li>
                    <ul style="list-style-type:disc">
                        <span *ngIf="dispositionResult.getHomeSupervisorName() !== ''">
                      <li> Supervised By:{{dispositionResult.getHomeSupervisorName()}}. </li></span>
                      <span *ngIf="dispositionResult.getSupervisionConditions() !== ''">
                      <li> Supervised Conditions: </li>
                      <ul style="list-style-type:disc">
                          <li> {{dispositionResult.getSupervisionConditions()}}. </li>
                      </ul></span>
                    </ul>
                </div>
                <div *ngIf="dispositionResult.getCustodyChangeIndicator() === 'Y'" >
                    <li>Custody [G.S 7B-2506(1)b.]:</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="dispositionResult.getParentCustodyIndicator() === 'Y'" >
                        <li> Juvenile Parents:{{dispositionResult.getChangedParentName()}}. </li>
                      </div>
                      <div *ngIf="dispositionResult.getMotherCustodyIndicator() === 'Y'" >
                        <li> Juvenile mother: {{dispositionResult.getChangedMotherName()}}. </li>
                      </div>
                      <div *ngIf="dispositionResult.getFatherCustodyIndicator() === 'Y'" >
                        <li> Juvenile father:{{dispositionResult.getChangedFatherName()}}. </li>
                      </div>
                      <div *ngIf="dispositionResult.getOtherCustodyIndicator() === 'Y'" >
                        <li> Other:{{dispositionResult.getChangedOtherName()}}. </li>
                      </div>
                      <div *ngIf="dispositionResult.getCountySSCustodyIndicator() === 'Y'" >
                        <li> County Department of Social Services:{{dispositionResult.getChangedCountySSName()}}. </li>
                      </div>
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getExcuseFromSchoolIndicator() === 'Y'" >
                    <li>Excuse from school attendance [G.S 7B-2506(2)]</li>
                    <span *ngIf="dispositionResult.getExcuseConditions() !== ''">
                    <ul style="list-style-type:disc">
                      <li> Conditions: </li>
                      <ul style="list-style-type:disc">
                          <li> {{dispositionResult.getExcuseConditions()}}. </li>
                      </ul>
                    </ul></span>
                </div>
                <div *ngIf="dispositionResult.getCoopWithSpecifiedProgramIndicator() === 'Y'" >
                    <li>Cooperate with specified program [G.S 7B-2506(3)] for {{dispositionResult.getCoopWithSpecifiedProgramDuration()}}</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="dispositionResult.getCommunityProgramIndicator() === 'Y'" >
                        <li> Community Based Program: {{dispositionResult.getCommunityProgramName()}} </li>
                      </div>
                      <div *ngIf="dispositionResult.getSubstanceAbuseProgramIndicator() === 'Y'" >
                        <li> Intensive substance abuse treatment program: {{dispositionResult.getSubstanceAbuseProgramName()}} </li>
                      </div>
                      <div *ngIf="dispositionResult.getResidentialProgramIndicator() === 'Y'" >
                        <li> Residential treatment program: {{dispositionResult.getResidentialProgramName()}} </li>
                      </div>
                      <div *ngIf="dispositionResult.getNonResidentialProgramIndicator() === 'Y'" >
                        <li> Non-Residential treatment program: {{dispositionResult.getNonResidentialProgramName()}} </li>
                      </div>                      
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getLevel1RestitutionIndicator() === 'Y'" >
                    <li>Restitution [G.S 7B-2506(4)]</li>
                    <ul style="list-style-type:disc">                     
                        <li> Restitution Amount: {{dispositionResult.getLevel1RestitutionAmount()}} </li>
                        <li> Benefit Name: {{dispositionResult.getLevel1RestitutionPayee()}} </li>
                        <li> Within:  {{dispositionResult.getLevel1RestitutionDuration()}} </li>
                        <li> Restitution Conditions:</li> 
                        <span *ngIf="dispositionResult.getLevel1RestitutionConditions() !== ''">                           
                            <ul style="list-style-type:disc">
                                <li> {{dispositionResult.getLevel1RestitutionConditions()}} </li>
                            </ul></span>
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getFinePayIndicator() === 'Y'" >
                    <li>Payment of Fine [G.S. 7B-2506(5)]</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="dispositionResult.getCommunityProgramIndicator() === 'Y'" >
                          <span *ngIf="dispositionResult.getFinePayAmount() !== ''">
                        <li> Fine Amount:  {{dispositionResult.getFinePayAmount()}} </li></span>
                      </div>                                            
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getLevel1CommunityService() === 'Y'" >
                    <li>Community Service [G.S. 7B-2506(6)]</li>
                    <ul style="list-style-type:disc"> 
                        <span *ngIf="dispositionResult.getLevel1CommunityServiceDuration() !== ''">                                             
                        <li>Hours: {{dispositionResult.getLevel1CommunityServiceDuration()}} </li></span>
                        <span *ngIf="dispositionResult.getLevel1CommunityConditions() !== ''">
                        <li>Community Service Conditions:</li>                            
                            <ul style="list-style-type:disc">
                                <li> {{dispositionResult.getLevel1CommunityConditions()}} </li>
                            </ul></span>
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getVictimOffenderReconcileIndicator() === 'Y'" >
                    <li>Victim-Offender Reconciliation [G.S. 7B-2506(7)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getNoDrivingLicenseIndicator() === 'Y'" >
                    <li>No Drivers License [G.S. 7B-2506(9)]</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="dispositionResult.getNoDrivingLicenseForJurisIndicator() === 'Y'" >
                        <li> Not operate a Motor vehicle for: {{dispositionResult.getNoDrivingLicenseDuration()}} </li>
                      </div>                                            
                      <div *ngIf="dispositionResult.getNoDrivingLicenseForJurisIndicator() === 'N'" >
                          <li>For as long as the court retains jurisdiction </li>
                        </div>                                            
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getCurfewIndicator() === 'Y'" >
                    <li>Curfew [G.S. 7B-2506(10)]</li>
                    <span *ngIf="dispositionResult.getCurfewConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getCurfewConditions()}} </li>                        
                    </ul></span>                    
                </div>
                <div *ngIf="dispositionResult.getNoPersonAssocIndicator() === 'Y'" >
                    <li>Not Associate with specified persons [G.S. 7B-2506(11)]</li>
                    <span *ngIf="dispositionResult.getNotAssociatePersonsConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getNotAssociatePersonsConditions()}} </li>                        
                    </ul></span>                    
                </div>
                <div *ngIf="dispositionResult.getNoPresencePlaceIndicator() === 'Y'" >
                    <li>Not be in specified places [G.S. 7B-2506(11)]</li>
                    <span *ngIf="dispositionResult.getNotInPlacesConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getNotInPlacesConditions()}} </li>                        
                    </ul></span>                    
                </div>
                <div *ngIf="dispositionResult.getLevel1IntermittantConfinementIndicator() === 'Y'" >
                    <li>Intermittent Confinement [G.S. 7B-2506(12)]</li>
                    <span *ngIf="dispositionResult.getLevel1ConfinementConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getLevel1ConfinementConditions()}} </li>                        
                    </ul></span>                    
                </div>
                <div *ngIf="dispositionResult.getLevel1WildernessProgramIndicator() === 'Y'" >
                    <li>Wilderness Program [G.S. 7B-2506(13)]</li>                   
                </div>
              </ul>
              </div>
              <div *ngIf="dispositionResult.isOrderLevel2DetailsPresent() === true">
              <B>Level 2:</B>
              <ul style="list-style-type:disc">
                  <div *ngIf="dispositionResult.getWildernessProgramIndicator() === 'Y'" >
                      <li>Wilderness Program [G.S 7B-2506(13)]</li>
                  </div>
                  <div *ngIf="dispositionResult.getPlacementProgramCoopIndicator() === 'Y'" >
                      <li>Cooperate With Placement in Specified Program [G.S 7B-2506(14)]:</li>
                      <ul style="list-style-type:disc">
                        <div *ngIf="dispositionResult.getPlacementProgramCode() === 'RTF'" >
                          <li> a residential treatment facility&nbsp;{{dispositionResult.getProgramDescription()}} </li>
                        </div>                                            
                        <div *ngIf="dispositionResult.getPlacementProgramCode() === 'NRT'" >
                            <li>an intensive nonresidential treatment program&nbsp;{{dispositionResult.getProgramDescription()}}  </li>
                        </div>                                            
                        <div *ngIf="dispositionResult.getPlacementProgramCode() === 'SAP'" >
                            <li> an intensive substance abuse program&nbsp;{{dispositionResult.getProgramDescription()}} </li>
                        </div>                                            
                        <div *ngIf="dispositionResult.getPlacementProgramCode() === 'SMP'" >
                            <li>a group home other than a multipurpose group home operated by a State agency.&nbsp;{{dispositionResult.getProgramDescription()}} </li>
                        </div>                                            
                      </ul>                    
                  </div>
                  <div *ngIf="dispositionResult.getIntensiveProbationIndicator() === 'Y'" >
                    <li>Intensive Probation [G.S 7B-2506(15)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getSupervisedDayProgramIndicator() === 'Y'" >
                    <li>Supervised Day Program [G.S 7B-2506(16)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getRegimentedTrainingIndicator() === 'Y'" >
                    <li>Regimented Training Program [G.S 7B-2506(17)]</li>
                    <span *ngIf="dispositionResult.getRegimentedTrainingProgConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getRegimentedTrainingProgConditions()}} </li>                        
                    </ul> </span>                   
                </div>
                <div *ngIf="dispositionResult.getHouseArrestIndicator() === 'Y'" >
                    <li>House Arrest [G.S 7B-2506(18)]</li>
                    <span *ngIf="dispositionResult.getHouseArrestConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getHouseArrestConditions()}} </li>                        
                    </ul></span>                 
                </div>
                <div *ngIf="dispositionResult.getIntermittantConfinementIndicator() === 'Y'" >
                    <li>Intermittent Confinement [G.S 7B-2506(20)]</li>
                    <span *ngIf="dispositionResult.getLevel2ConfinementConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getLevel2ConfinementConditions()}} </li>                        
                    </ul></span>            
                </div>
                <div *ngIf="dispositionResult.getStateMultiPurposeGroupHomeIndicator() === 'Y'" >
                    <li>Placement In State Multipurpose Group Home [G.S 7B-2506(21)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getLevel2RestitutionIndicator() === 'Y'" >
                    <li>Restitution [G.S 7B-2506(22)]</li>
                    <ul style="list-style-type:disc">                      
                        <li> Restitution Amount : {{dispositionResult.getLevel2RestitutionAmount()}} </li>
                        <li> Benefit Name: {{dispositionResult.getLevel2RestitutionPayee()}} </li>
                        <li> Within :  {{dispositionResult.getLevel2RestitutionDuration()}} </li>
                        <li> Restitution Conditions:</li>  
                        <span *ngIf="dispositionResult.getLevel2RestitutionConditions() !== ''">                          
                            <ul style="list-style-type:disc">
                                <li> {{dispositionResult.getLevel2RestitutionConditions()}} </li>
                            </ul></span>
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getLevel2CommunityService() === 'Y'" >
                    <li>Community Service [G.S 7B-2506(23)]</li>
                    <ul style="list-style-type:disc">
                        <span *ngIf="dispositionResult.getLevel2CommunityServiceDuration() !== ''">                                              
                        <li>Hours :  {{dispositionResult.getLevel2CommunityServiceDuration()}} </li></span>
                        <span *ngIf="dispositionResult.getLevel2CommunityConditions() !== ''">
                        <li>{{dispositionResult.getLevel2CommunityConditions()}}</li></span>                            
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getSuspendMoreSevereDisposition() === 'Y'" >
                    <li>Suspension of More Severe Disposition [G.S 7B-2506(19)]&nbsp;{{dispositionResult.getDispositionListByPara()}}</li>
                    <span *ngIf="dispositionResult.getSuspSevereDispConditions() !== ''">
                    <ul style="list-style-type:disc">                                                                      
                        <li> {{dispositionResult.getSuspSevereDispConditions()}} </li>                        
                    </ul></span>                    
                </div>
              </ul></div>
              <div *ngIf="dispositionResult.isOrderOtherDetialsPresent() === true">
              <B>Other</B>
              <ul style="list-style-type:disc">
                <div *ngIf="dispositionResult.getFamilyPlanIndicator() === 'Y'" >
                    <li>Continuance for family to implement approved plan [G.S. 7B-2501(d)]</li>
                    <ul style="list-style-type:disc">                                                                      
                        <span *ngIf="dispositionResult.getFamilyPlanDuration() !== ''">
                        <li>Case continued for&nbsp; {{dispositionResult.getFamilyPlanDuration()}} &nbsp;months(not to exceed 6 months). </li></span>  
                        <span *ngIf="dispositionResult.getFamilyPlanConditions() !== ''">
                        <li>{{dispositionResult.getFamilyPlanConditions()}}</li></span>                      
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getExamByExpertIndicator() === 'Y'" >
                    <li>Examination by expert [G.S. 7B-2502(a)]</li>
                    <ul style="list-style-type:disc">                                                                      
                        <span *ngIf="dispositionResult.getExamByExpertNameType() !== ''">
                        <li>Expert Name : {{dispositionResult.getExamByExpertNameType()}}</li></span>  
                        <span *ngIf="dispositionResult.getExamByExpertDate() !== ''">
                        <li>Date : {{dispositionResult.getExamByExpertDate()}}</li></span>                      
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getIndisciplineEvaluation() === 'Y'" >
                    <li>Interdisciplinary evaluation [G.S. 7B-2502(c)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getSubstanceTestIndicator() === 'Y'" >
                    <li>Testing for use of Controlled Substances [G.S. 7B-2502(a)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getAlcoholTestIndicator() === 'Y'" >
                    <li>Testing for use of alcohol [G.S. 7B-2502(a)]</li>                   
                </div>
                <div *ngIf="dispositionResult.getPgcRequirementIndicator() === 'Y'" >
                    <li>Requirements for Parent, Guardian, Custodian [G.S. 7B-2700 through -2704]</li>
                    <ul style="list-style-type:disc">
                      <div *ngIf="dispositionResult.getReqtMother() === 'Y'" >
                        <li> Mother  </li>
                      </div>                                            
                      <div *ngIf="dispositionResult.getReqtFather() === 'Y'" >
                          <li>Father  </li>
                      </div>  
                      <div *ngIf="dispositionResult.getReqtGuardian() === 'Y'" >
                        <li> Guardian   </li>
                      </div>                                            
                      <div *ngIf="dispositionResult.getReqtCustodian() === 'Y'" >
                          <li>Custodian   </li>
                      </div>
                      <span *ngIf="dispositionResult.getNextHearingDate() !== ''">
                      <li>Next Hearing</li>
                      <li>Next Hearing Date : {{dispositionResult.getNextHearingDate()}}</li>
                      </span>                                           
                    </ul>                    
                </div>
                <div *ngIf="dispositionResult.getOtherOrderIndicator() === 'Y'" >
                    <li>Other</li>
                    <ul style="list-style-type:disc">                                                                      
                        <span *ngIf="dispositionResult.getOtherConditions() !== ''">
                        <li> {{dispositionResult.getOtherConditions()}} </li></span>                        
                    </ul>                    
                </div>
              </ul></div>
            </div>    
        </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/disposition-result/disposition-result.component.html